export default "__VITE_ASSET__4a68f17b__"